import React from 'react'
import { Grid, Card } from '@design-systems/canvas-ui'
import { SearchResultsItem } from './SearchResultsGroup'
import Icon from '@design-systems/react-icons'
import styles from '../../pages/SearchResultsPage.module.css'

const SearchResultItem: React.FC<SearchResultsItem> = ({
  nameSlot,
  captionSlot,
  icon,
  iconColor,
}) => {
  return (
    <Grid.Container align="center" justify="center">
      <Card variant="border" className="hc8-pa-1x">
        <Icon
          svg={icon}
          color={iconColor}
          className={`hc8-mb-2x hc8-mt-2x ${styles.customIconSize}`}
        />
      </Card>
      <Grid.Item className="hc8-mt-3x hc8-ph-2x" size={{ xs: 12 }}>
        <Grid.Item
          className={`hc8-mb-1x ${styles.searchTermText}`}
          size={{ xs: 12 }}
        >
          <strong>{nameSlot}</strong>
        </Grid.Item>
        <Grid.Item className={styles.searchTermText} size={{ xs: 12 }}>
          {captionSlot}
        </Grid.Item>
      </Grid.Item>
    </Grid.Container>
  )
}

export default SearchResultItem
